import login from './login';

export default {
  language: 'ua',
  country: 'ua',
  name: 'Українська',
  embeddedLocale: login,
};
